import { MinimapPlugin } from './MinimapPlugin';
import { CursorPlugin } from './CursorPlugin';
import { SegmentsPlugin } from './SegmentsPlugin';

export { CursorPlugin, MinimapPlugin, SegmentsPlugin };
